// extracted by mini-css-extract-plugin
export default {"rewardTitle":"AXE2O","rewardPrice":"GsrRa","rewardRemove":"Zd6kt","item":"oRLky","hideCountButtons":"b6bac","itemQuantity":"N3Q2w"};